<template>
  <div>
    <slot v-if="!display.smAndDown" :event="addAndroidCalendar"></slot>
    <SmPopover v-else class="popover">
      <template v-slot:trigger="{ togglePopover }">
        <slot :event="togglePopover"></slot>
      </template>

      <template v-slot:content>
        <div class="popover__content">
          <div class="popover__content--link" @click="addAndroidCalendar">
            <GoogleIcon />
            <span>Google</span>
          </div>
          <div class="popover__content--devider"></div>
          <div class="popover__content--link" @click="addIosCalendar">
            <AppleIcon />
            <span>Apple</span>
          </div>
        </div>
      </template>
    </SmPopover>
  </div>
</template>
<script>
import { format, add, parseISO } from 'date-fns'
import { googleCalendarEventUrl } from 'google-calendar-url'
import { createEvent } from 'ics'

import { useDisplay } from '@/hooks'
import { SmPopover } from '@/shared'

import AppleIcon from '@/assets/icons/apple'
import GoogleIcon from '@/assets/icons/google'

export default {
  name: 'CalendarEventButton',
  props: ['admissionInfo'],
  components: {
    SmPopover,
    AppleIcon,
    GoogleIcon
  },
  setup(props) {
    const { admissionInfo } = props

    const display = useDisplay()

    function getCalendarTitle() {
      const doctor = admissionInfo.doctor
      let text = 'Приём в СМ Клинике: '

      text += `${admissionInfo.specializationTitle}, ${doctor.surname ?? ''} ${
        doctor.name ?? ''
      }`

      return text
    }

    function addAndroidCalendar() {
      const title = getCalendarTitle()
      const location = admissionInfo.clinic.address
      const start = format(
        parseISO(admissionInfo.dateTime),
        "yyyyMMdd'T'HHmmss"
      )
      const end = format(
        add(parseISO(admissionInfo.dateTime), { hours: 1 }),
        "yyyyMMdd'T'HHmmss"
      )

      const url = googleCalendarEventUrl({
        start,
        end,
        title,
        location
      })

      window.open(url, '_blank')
    }

    async function addIosCalendar() {
      const clinic = admissionInfo.clinic
      const title = getCalendarTitle()
      const location = clinic.address
      const start = format(
        parseISO(admissionInfo.dateTime),
        "yyyyMMdd'T'HHmmss"
      )
      const end = format(
        add(parseISO(admissionInfo.dateTime), { hours: 1 }),
        "yyyyMMdd'T'HHmmss"
      )

      const event = {
        start,
        end,
        title,
        location,
        geo: { lat: clinic.latitude, lon: clinic.longitude }
      }

      const filename = 'VisitSmClinic.ics'
      const file = await new Promise((resolve, reject) => {
        createEvent(event, (e, v) => {
          if (e) reject(e)
          resolve(new File([v], filename, { type: 'text/calendar' }))
        })
      })
      const url = URL.createObjectURL(file)
      const anchor = document.createElement('a')

      anchor.href = url
      anchor.download = filename

      document.body.appendChild(anchor)
      anchor.click()
      document.body.removeChild(anchor)

      URL.revokeObjectURL(url)
    }

    return {
      display,
      addIosCalendar,
      addAndroidCalendar
    }
  }
}
</script>
<style lang="scss" scoped>
@import 'style';
</style>
